<template>
    <v-flex align="center" class="bg-white text-dark" justify="center">
        <div class="p-3 p-md-0 reset">
            <h4>Reset your password</h4>
            <p
                v-if="!token"
            >If your email matches one in our system, we'll send you a link to reset your password.</p>
            <v-auth-reset :suggested-email="email" :token="token" />
        </div>
    </v-flex>
</template>

<script>
import VAuthReset from "@/components/ui/VAuthReset";

export default {
    name: "IndexReset",
    components: {
        VAuthReset
    },
    props: {
        token: {
            required: false,
            type: String
        },
        email: {
            required: false,
            type: String
        }
    }
};
</script>

<style scoped lang="scss">
.reset {
    max-width: 40vw !important;
    width: 40vw !important;
}
@media (max-width: #{map-get($grid-breakpoints, "md")}) {
    .reset {
        max-width: 100vw !important;
        width: 100vw !important;
    }
}
</style>